import { createContext, useContext } from "react";

// Summary tables can be viewed in weight (%) mode or dollar ($) mode.
// One shared mode across the whole explain page, surfaced by toggles
// in each account's Summary title band (see SummaryRow.tsx). Persisted
// across navigation so analysts don't fight muscle memory when
// bouncing between rebalances.
export type DisplayMode = "weight" | "dollar";

export interface DisplayModeContextValue {
  mode: DisplayMode;
  setMode: (m: DisplayMode) => void;
}

export const DisplayModeContext = createContext<DisplayModeContextValue>({
  mode: "weight",
  setMode: () => {
    /* no-op default; real value comes from the page-level provider */
  },
});

export const useDisplayMode = (): DisplayModeContextValue =>
  useContext(DisplayModeContext);

export function loadInitialDisplayMode(): DisplayMode {
  try {
    const v = localStorage.getItem("explain-v3-display-mode");
    return v === "dollar" ? "dollar" : "weight";
  } catch {
    return "weight";
  }
}

export function persistDisplayMode(mode: DisplayMode): void {
  try {
    localStorage.setItem("explain-v3-display-mode", mode);
  } catch {
    /* ignore quota / private browsing */
  }
}
